import { createClient } from '@/lib/supabase/client';

export interface PublicNewsletter {
  title: string;
  subject: string;
  sentAt: string | null;
  html: string;
}

export interface NewsletterListItem {
  slug: string;
  title: string;
  sentAt: string | null;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatNewsletterDate(value: string | null | undefined): string {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

function firstRow(data: any): any | null {
  if (!data) return null;
  if (Array.isArray(data)) return data.length > 0 ? data[0] : null;
  return data;
}

export const newsletterService = {
  async getBySlug(slug: string): Promise<PublicNewsletter | null> {
    const supabase = createClient();
    const { data, error } = await supabase.rpc('public_newsletter', { p_slug: slug });
    if (error) throw error;
    const row = firstRow(data);
    if (!row || !row.html) return null;
    return {
      title: row.title ?? '',
      subject: row.subject ?? '',
      sentAt: row.sent_at ?? null,
      html: row.html as string,
    };
  },

  async list(): Promise<NewsletterListItem[]> {
    const supabase = createClient();
    const { data, error } = await supabase.rpc('public_newsletter_list');
    if (error) throw error;
    const rows: any[] = Array.isArray(data) ? data : data ? [data] : [];
    return rows
      .filter((r) => r && r.slug)
      .map((r) => ({
        slug: r.slug as string,
        title: (r.title ?? r.subject ?? r.slug) as string,
        sentAt: (r.sent_at ?? null) as string | null,
      }));
  },
};
